(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
  jQuery(document).ready(function(){
    var j = jQuery; //Just a variable for using jQuery without conflicts
    var addInput = '.quantity-selector .product-form__quantity'; //This is the id of the input you are changing
    var n = parseInt(j(addInput).val()); //n is equal to 1
	var min = parseInt(j(addInput).data('min'));

	//Set default value to n (n = 1)
    j(addInput).val(n);

    //On click add 1 to n
    j('.plus').on('click', function(){
	  var c = parseInt(j(addInput).val()) + n;
      j(addInput).val(c);
    });

    j('.min').on('click', function(){
      //If n is bigger or equal to 1 subtract 1 from n
	  var cV = parseInt(j(addInput).val());
	  
	  if (cV > min) {
		var c = cV - n;
        j(addInput).val(c);
      } else {
        //Otherwise do nothing
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
